module.exports = __webpack_public_path__ + "img/手机端商品.6688773e.png";